import { FC, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store';
import { getOptionsEstablishment, selectOptionsEstablishment, selectOptionsEstablishmentState } from '../../../store/entities/optionsEstablishment';
import { FetchState } from '../../../store/fetchState';
import { selectIdentityCompanyId } from '../../../store/entities/identity';
import axios, { CancelToken } from 'axios';
import { SxProps, Theme } from '@mui/material';
import { getLangNameObj } from '../../../utils/format';
import { useTranslation } from 'react-i18next';
import { PreSelectSingle } from './PreselectSingle';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';

interface Props {
  sx?: SxProps<Theme>;
  name: string;
  label?: React.ReactNode;
  required?: boolean;
  fullWidth?: boolean;
}

export const EstablishmentBasic: FC<Props> = ({ name, label, required, fullWidth }) => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const identityCompanyId = useAppSelector(selectIdentityCompanyId);
  const optionsEstablishment = useAppSelector(selectOptionsEstablishment);
  const optionsEstablishmentState = useAppSelector(
    selectOptionsEstablishmentState
  );

  useEffect(() => {
    const loadOptions = (
      search: string | undefined,
      cancelToken: CancelToken
    ) => {
      dispatch(getOptionsEstablishment(search, cancelToken));
    };

    loadOptions(
      undefined,
      new axios.CancelToken((c) => console.log('Cancel token:', c))
    );
  }, [dispatch, identityCompanyId]);

  return (
    <PreSelectSingle
      name={name}
      label={label}
      required={required}
      options={optionsEstablishment}
      loading={optionsEstablishmentState === FetchState.Loading}
      getOptionId={(option: ReferenceDto) => option.id!}
      getOptionName={(option: ReferenceDto) => getLangNameObj(i18n, option)}
      getOptionNameFromId={(opt) => opt}
      fullWidth={fullWidth}
    />
  );
};
